/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface SingleFileContentsUpdateHandlerBodyRequest {
  /**
   * 파일 ID
   * @example "671232a77b67320e303b0592"
   */
  fileID: string;
  /**
   * 파일 타입 - 300: 이미지, 400: 비디오, 500: 파일
   * @example 300
   */
  type?: number;
  /**
   * 삭제할 파일 URL 목록
   * @example ["https://example.com/1.jpg","https://example.com/2.jpg"]
   */
  toBeRemovedUrls?: string[];
  /** 추가할 파일 AWS Object 목록 */
  toBeAddedAWSObjectArray?: {
    /**
     * AWS S3 ETag
     * @example "d41d8cd98f00b204e9800998ecf8427e"
     */
    ETag?: string;
    /**
     * AWS S3 URL
     * @example "https://example.com/1.jpg"
     */
    Location: string;
    /**
     * AWS S3 Key
     * @example "1.jpg"
     */
    Key: string;
    /**
     * AWS S3 Bucket
     * @example "example-bucket"
     */
    Bucket?: string;
    /**
     * 이미지 정보
     * @example {"width":1920,"height":1080}
     */
    size?: {
      /**
       * 이미지 너비
       * @example 1920
       */
      width: number;
      /**
       * 이미지 높이
       * @example 1080
       */
      height: number;
    };
    /**
     * 바이트 단위 파일 크기
     * @example 1024
     */
    fileSize?: number;
    /**
     * 원본 파일 이름
     * @example "1.jpg"
     */
    fileName?: string;
  }[];
}

export interface SingleFileContentsUpdateHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 파일 내용 업데이트 성공 여부
     * @example true
     */
    isUpdatedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface FileControllerCreateUploadUrlBodyRequest {
  /** 업로드할 파일명 (확장자 포함) */
  fileName: string;
  /** 파일 MIME 타입 (예: application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) */
  contentType: string;
  /** S3 키 prefix (기본값: uploads) */
  keyPrefix?: string;
}

export interface FileControllerCreateUploadUrlResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** S3 presigned PUT URL */
    url: string;
    /** S3 객체 키 */
    key: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface FileControllerCreatePublicUploadUrlBodyRequest {
  /** 업로드할 파일명 (확장자 포함) */
  fileName: string;
  /** 파일 MIME 타입 (예: application/vnd.openxmlformats-officedocument.spreadsheetml.sheet) */
  contentType: string;
  /** S3 키 prefix (기본값: uploads) */
  keyPrefix?: string;
}

export interface FileControllerCreatePublicUploadUrlResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** S3 presigned PUT URL */
    url: string;
    /** S3 객체 키 */
    key: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export type ApiFilesData = ApiResponse & {
  data: {
    /** 업로드된 파일 URL 목록 */
    paths?: string[];
    aws?: {
      /** 파일의 고유 식별자 */
      ETag?: string;
      /** 업로드된 파일의 URL */
      Location?: string;
      /** S3 버킷 내 파일 경로 */
      key?: string;
      /** S3 버킷 내 파일 경로 (key와 동일) */
      Key?: string;
      /** S3 버킷 이름 */
      Bucket?: string;
      size?: {
        /** 이미지 너비 (픽셀) */
        width?: number;
        /** 이미지 높이 (픽셀) */
        height?: number;
      };
      /** 파일 크기 (바이트) */
      fileSize?: number;
      /** 원본 파일 이름 */
      fileName?: string;
    }[];
    /** 생성된 문서의 ID */
    _id?: string;
    /** 사용자 ID */
    userID?: string;
    /** 파일 타입 */
    type?: number;
    /**
     * 문서 생성 시간
     * @format date-time
     */
    createdAt?: string;
    /**
     * 문서 최종 수정 시간
     * @format date-time
     */
    updatedAt?: string;
    /** 문서 버전 정보 */
    __v?: number;
  };
};

export type SingleFileContentsUpdateHandlerData = SingleFileContentsUpdateHandlerResponse;

export type FileControllerCreateUploadUrlData = FileControllerCreateUploadUrlResponse;

export type FileControllerCreatePublicUploadUrlData = FileControllerCreatePublicUploadUrlResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 사용자가 업로드한 파일 정보를 저장합니다.
     *
     * @tags V3-File
     * @name ApiFiles
     * @summary 파일 업로드 API
     * @request POST:/v3/api/files
     * @secure
     * @response `200` `ApiFilesData` 파일 업로드 성공
     */
    apiFiles: (
      data: {
        /** 사용자 ID */
        userID: string;
        /** 파일 타입 */
        type: number;
        /** 업로드된 파일 URL 목록 */
        paths: string[];
        aws: {
          /** 파일의 고유 식별자 */
          ETag?: string;
          /** 업로드된 파일의 URL */
          Location?: string;
          /** S3 버킷 내 파일 경로 */
          key?: string;
          /** S3 버킷 내 파일 경로 (key와 동일) */
          Key?: string;
          /** S3 버킷 이름 */
          Bucket?: string;
          size?: {
            /** 이미지 너비 (픽셀) */
            width?: number;
            /** 이미지 높이 (픽셀) */
            height?: number;
          };
          /** 파일 크기 (바이트) */
          fileSize?: number;
          /** 원본 파일 이름 */
          fileName?: string;
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiFilesData, any>({
        path: `/v3/api/files`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 파일 id 내부 콘텐츠 정보를 부분 수정합니다.
     *
     * @tags V3-File
     * @name SingleFileContentsUpdateHandler
     * @summary 단일 파일 내부 콘텐츠 정보 부분 수정
     * @request PATCH:/v3/api/files
     * @secure
     * @response `200` `SingleFileContentsUpdateHandlerData` success
     */
    singleFileContentsUpdateHandler: (data: SingleFileContentsUpdateHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<SingleFileContentsUpdateHandlerData, any>({
        path: `/v3/api/files`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description S3 presigned PUT URL을 발급합니다. 업로드된 파일은 비공개이며 서버를 통해서만 읽을 수 있습니다.
     *
     * @tags File
     * @name FileControllerCreateUploadUrl
     * @summary presigned 업로드 URL 발급 (비공개)
     * @request POST:/v3/api/files/upload-url
     * @secure
     * @response `200` `FileControllerCreateUploadUrlData` success
     */
    fileControllerCreateUploadUrl: (data: FileControllerCreateUploadUrlBodyRequest, params: RequestParams = {}) =>
      this.request<FileControllerCreateUploadUrlData, any>({
        path: `/v3/api/files/upload-url`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 공개 파일용 S3 presigned PUT URL을 발급합니다. 업로드된 파일은 public-read 로 누구나 URL 로 조회할 수 있으므로, 공개되어도 되는 파일(채팅 첨부 등)에만 사용합니다.
     *
     * @tags File
     * @name FileControllerCreatePublicUploadUrl
     * @summary presigned 업로드 URL 발급 (공개)
     * @request POST:/v3/api/files/upload-url/public
     * @secure
     * @response `200` `FileControllerCreatePublicUploadUrlData` success
     */
    fileControllerCreatePublicUploadUrl: (
      data: FileControllerCreatePublicUploadUrlBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<FileControllerCreatePublicUploadUrlData, any>({
        path: `/v3/api/files/upload-url/public`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
